<template>
  <div v-show="shouldShowParametersInputAndLabel">
    <label
      :for="`parameters-input-${id}`"
      class="sc3-form-label sc3-form-label-inline sc3-form-label-small"
      v-if="shouldShowLabel"
    >PARAMETERS</label>
    <br v-if="shouldShowLabel" />
    <input
      :class="{ 'hidden': !shouldDisplayParametersInput }"
      type="text"
      placeholder=""
      class="sc3-text-input sc3-text-input-inline sc3-text-input-compact sc3-text-input-grey-and-black sc3-text-input-no-margins"
      :id="`parameters-input-${id}`"
      :value="parameters"
      @change="handleParametersChanged($event)"
      ref="parametersInputElement"
      @keydown.enter="handleEnterKeyDownParametersInput()"
      @blur="handleBlurParametersInput()"
      autocomplete="off"
    />
  </div>
</template>

<script lang="ts" setup>
  import { ref, toRefs, computed } from 'vue';
  import { NONE, DATE_TIME_AXIS } from '@/enums/indicators-and-overlays';

  const props = defineProps<{
    parameters: string;
    id: string;
    shouldShowLabel: boolean;
    indicatorOrOverlayName: string;
    isIndicatorParameters: boolean;
    isOverlayParameters: boolean;
    isIndicatorOverlayParameters: boolean;
    isAtLeastOneNonDateTimeAxisIndicatorPresent: boolean;
    isAtLeastOneOverlayPresent: boolean;
    isAtLeastOneOverlayOfIndicatorPresent: boolean;
  }>();
  const {
    parameters,
    id,
    shouldShowLabel,
    indicatorOrOverlayName,
    isIndicatorParameters,
    isOverlayParameters,
    isIndicatorOverlayParameters,
    isAtLeastOneNonDateTimeAxisIndicatorPresent,
    isAtLeastOneOverlayPresent,
    isAtLeastOneOverlayOfIndicatorPresent
  } = toRefs(props);

  const emit = defineEmits<{
    (e: 'update:parameters', parameters: string): void;
    (e: 'parametersChanged'): void;
  }>();

  const parametersInputElement = ref<HTMLInputElement>();

  const shouldDisplayParametersInput = computed(() => {
    return ![NONE, DATE_TIME_AXIS.name].includes(indicatorOrOverlayName.value);
  });

  const shouldShowParametersInputAndLabel = computed(() => {
    return (
        (isOverlayParameters.value && isAtLeastOneOverlayPresent.value) ||
        (isIndicatorParameters.value && isAtLeastOneNonDateTimeAxisIndicatorPresent.value) ||
        (isIndicatorOverlayParameters.value && isAtLeastOneOverlayOfIndicatorPresent.value)
    );
  });

  function handleParametersChanged(e: Event) {
    if (!(e.target instanceof HTMLInputElement)) {
      return;
    }

    emit('update:parameters', e.target.value);
  }

  function handleEnterKeyDownParametersInput() {
    parametersInputElement.value?.blur();
  }

  function handleBlurParametersInput() {
    emit('parametersChanged');
  }
</script>

<style scoped>
  .hidden {
    visibility: hidden;
  }
</style>
